import memoize from 'fast-memoize';
import { CHANNEL_MAPPING } from 'constants/channels';
import { supportedChannelNamesList } from 'helpers/channels';

const lookup = {
    cpc: 'CPC',
    cpcv: 'CPCV',
    ctr: 'CTR',
    ecpa: 'eCPA',
    ecpa_activities: 'eCPA Activities'
};

function _prefixKeywordsWithSpace(keywords) {
    keywords.map((keyword) => {
        // Add a space to keywords that start with a "+" so that the exported CSVs load correctly
        if (keyword.keyword.startsWith('+')) {
            keyword.keyword = ` ${keyword.keyword}`;
        }

        return keyword;
    });

    return keywords;
}

exports.prefixKeywordsWithSpace = memoize(_prefixKeywordsWithSpace);

function _capitalizeFirstLetter(string) { return string ? string.charAt(0).toUpperCase() + string.slice(1) : string; }

function _convertToDisplayValue(string) {
    // Test if this is a Channel Name
    if (supportedChannelNamesList.includes(string)) {
        // If so, use the set channel name
        return CHANNEL_MAPPING[string].displayName;
    } else if (string && string in lookup) { // Test if this is a known lookup
        return lookup[string];
    } else if (/_/.test(string)) { // Assume that _ are the devil
        // Replace _ with space and _capitalizeFirstLetter
        return string.split('_').map(_capitalizeFirstLetter).join(' ').replace(/\s\s+/g, ' ')
            .trim();
    }

    // Upcase the first letter only
    return _capitalizeFirstLetter(string);
}
exports.capitalizeFirstLetter = memoize(_capitalizeFirstLetter);
exports.convertToDisplayValue = memoize(_convertToDisplayValue);

exports.getChannelDisplayValue = memoize((input) => {
    if (supportedChannelNamesList.includes(input)) {
        return CHANNEL_MAPPING[input].displayName;
    }

    return input;
});

function _convertToHeaderDisplayValue(string) {
    switch (string.toLowerCase()) {
    case 'ecpa activities':
    case 'ecpa_activities':
        return 'eCPA ACTIVITIES';
    case 'ekpi activities':
    case 'ekpi_activities':
        return 'eKPI ACTIVITIES';
    default:
        return exports.convertToDisplayValue(string).toUpperCase();
    }
}

exports.convertToHeaderDisplayValue = memoize(_convertToHeaderDisplayValue);

function _stripJobNumber(string) {
    return string.replace(/(IP|G)[\d]{5,7}[\s_-]*/g, '');
}

exports.stripJobNumber = memoize(_stripJobNumber);




// WEBPACK FOOTER //
// ./src/helpers/strings.js